import { resetExternalToolWorkForChat } from './external-tool-result-coordinator';
import { cancelForegroundSessionQueues } from './terminal-execution-queue';
import { suppressTerminalResume } from './terminal-resume-suppress';

export async function cancelForegroundTerminalsForChat(
  chatId: string,
): Promise<void> {
  const commandApi =
    typeof window === 'undefined' ? undefined : window.electronAPI?.command;

  if (!commandApi) {
    return;
  }

  try {
    await commandApi.killByChatId(chatId);
  } catch (error) {
    console.warn(
      '[TerminalExecution] Failed to cancel running commands for chat',
      error,
    );
  }
}

export async function abortChatForegroundWork({
  chatId,
}: {
  chatId: string;
}): Promise<void> {
  suppressTerminalResume(chatId);
  resetExternalToolWorkForChat(chatId);
  cancelForegroundSessionQueues(chatId);
  await cancelForegroundTerminalsForChat(chatId);
}
